import i18n from '@/i18n'
import { title } from '@/config'
import { ZH_CODE } from '@transsion/hotent-ui/packages/Language'

import {
  fetchTranslations,
  SUCCESS_CODE,
} from '@transsion/hotent-ui/src/plugins/auto-translate/api'
export const CHINESE_REGEX = /[\u4E00-\u9FA5]+/
/**
 * 设置标题
 * @param defaultTitle
 */
export default async function updatePageTitle(defaultTitle) {
  if (!defaultTitle) {
    document.title = title

    return
  }

  const locale = i18n.locale

  if (locale === ZH_CODE || !CHINESE_REGEX.test(defaultTitle)) {
    document.title = `${defaultTitle} - ${title}`
  }

  let translatedTitle = defaultTitle

  try {
    const res = await fetchTranslations([defaultTitle], {
      to: locale,
      fromLocale: { value: ZH_CODE },
    })

    if (+res.code === SUCCESS_CODE) {
      translatedTitle = res.result?.texts?.[0]
    }
  } finally {
    document.title = `${translatedTitle} - ${title}`
  }
}
